module.exports = __webpack_public_path__ + "static/img/ioz.ced5ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ioz.png
// module id = 62WO
// module chunks = 1